module.exports = __webpack_public_path__ + "image/solution_icon3.png";